import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Embed View Config"})
export default class EmbedViewConfig {

	@Input({type: InputType.UNIT, title: "Height"})
	public height: string;

	@Input({type: InputType.UNIT, title: "Width"})
	public width: string;

	@Input({type: InputType.BORDER, title: "Border"})
	public border: string;

}



// WEBPACK FOOTER //
// ./src/common/views/embed/EmbedViewConfig.ts